import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

interface Product {
    name: string;
    category: string;
}

@Component({
    selector: 'demo-upp-search',
    templateUrl: './demo-upp-search.html',
    styleUrls: ['../demo-common.scss', './demo-upp-search.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppSearchComponent {
    searchTerm = '';

    products: Product[] = [
        { name: 'Espresso', category: 'Coffee' },
        { name: 'Cappuccino', category: 'Coffee' },
        { name: 'Croissant', category: 'Bakery' },
        { name: 'Orange Juice', category: 'Drinks' },
        { name: 'Club Sandwich', category: 'Food' },
        { name: 'Cheesecake', category: 'Dessert' },
        { name: 'Green Tea', category: 'Tea' },
        { name: 'Caesar Salad', category: 'Food' },
    ];

    constructor(private change: ChangeDetectorRef) {
    }

    get filteredProducts(): Product[] {
        if (!this.searchTerm) {
            return this.products;
        }
        const term = this.searchTerm.toLowerCase();
        return this.products.filter(p =>
            p.name.toLowerCase().includes(term) || p.category.toLowerCase().includes(term)
        );
    }

    onSearchChanged(value: string | null) {
        this.searchTerm = value || '';
        this.change.markForCheck();
    }
}
